export const AuthErrorType = {
  '6010': 'invalid_credentials',
  '6011': 'invalid_credentials|warning_1',
  '6012': 'invalid_credentials|warning_2',
  '6022': 'account_locked',

  // temporary password
  '6031': 'password_expired',
  '6032': 'temp_password_update_required',
  '6033': 'temp_password_and_terms_update_required',
  '6040': 'account_not_found',
  '6050': 'account_not_found',

  // password reset
  '6101': 'account_not_found',

  // username recovery
  '6201': 'account_not_found',

  '7001': 'otp_invalid',
  '7002': 'otp_invalid|warning_1',
  '7003': 'otp_invalid|warning_2',
  // '7010': 'otp_sent',
  '7101': 'secret_answer_invalid',
  '7102': 'secret_answer_invalid|warning_1',
  '7103': 'secret_answer_invalid|warning_2',
  '7201': 'registration_incomplete'
};
